import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n/i18n'
import App from './App'
import { trackException } from '@/services/appInsights'
import { installNavigationGuard } from '@/utils/navigationGuard'
import { applyViewportPolicy } from '@/utils/viewportPolicy'
import { RESPONSIVE_LAYOUT_ENABLED } from '@/theme/breakpoints'

// Loaded after index.css so its overrides win at equal specificity. Skipped entirely while
// mobile/tablet layouts are disabled, which leaves the desktop stylesheet in sole control.
if (RESPONSIVE_LAYOUT_ENABLED) {
  await import('./responsive.css')
}

applyViewportPolicy()

// Global error handler for synchronous JS errors (e.g., in event handlers).
// Promise rejections are already auto-captured by the App Insights SDK.
window.onerror = (_msg, _source, _lineno, _colno, error) => {
  trackException(error ?? new Error(String(_msg)))
}

// Must run before the root renders: React Router attaches its own popstate listener while
// <BrowserRouter> first renders, and popstate listeners fire in registration order.
installNavigationGuard()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
